import { OrderListOutput } from "interfaces/front/OrderListOutput";
import { useAsyncMemo } from "lib/hooks/useAsyncMemo";
import { FrontOrderService} from "lib/service/client/FrontOrderService";

export const useOrderSummaryList = (service: FrontOrderService): OrderListOutput | null | undefined => {
  return useAsyncMemo(async () => {
    const result = await service.list();
    if (result.isSuccess()) {
      return result.value;
    } else {
      return null;
    }
  }, [service]);
};
